<template>
  <div
    class="modal fade"
    :id="modalId"
    tabindex="-1"
    aria-labelledby="modalLabel"
    aria-hidden="true"
    ref="modal"
  >
    <div
      class="modal-dialog shadow-md modal-fullscreen-md-down modal-dialog-centered"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalLabel">{{ title }}</h5>
          <button
            type="button"
            class="btn-close"
            @click="cancel"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          {{ message }}
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="cancel">
            Abbrechen
          </button>
          <button type="button" class="btn btn-danger" @click="confirm">
            {{ confirmButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";

export default {
  props: {
    title: String,
    message: String,
    confirmButtonText: {
      type: String,
      default: "Bestätigen",
    },
    modalId: {
      type: String,
      default: "confirmDialog",
    },
  },
  emits: ["confirm", "cancel"],
  data() {
    return {
      modalInstance: null,
    };
  },
  mounted() {
    this.modalInstance = new Modal(this.$refs.modal);
  },
  methods: {
    show() {
      this.modalInstance.show();
    },
    hide() {
      this.modalInstance.hide();
    },
    confirm() {
      this.$emit("confirm");
      this.hide();
    },
    cancel() {
      this.$emit("cancel");
      this.hide();
    },
  },
};
</script>
